const arrayMove = (arr: ISavedInstrument[], oldIndex: number, newIndex: number) => {
  if (newIndex >= arr.length) {
    const k = newIndex - arr.length + 1;
    while (k - 1) {
      arr.push({} as ISavedInstrument);
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
  return arr;
};

export default arrayMove;
